(function () {
  function initHeader(root) {
    var header = root.querySelector('[data-g-header]');
    var menu = root.querySelector('[data-g-mobile-nav]');
    var openButton = root.querySelector('[data-g-menu-open]');
    var closeButton = root.querySelector('[data-g-menu-close]');

    if (header && header.dataset.gBound !== 'true') {
      header.dataset.gBound = 'true';
      var setHeaderState = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 12);
      };
      setHeaderState();
      window.addEventListener('scroll', setHeaderState, { passive: true });
    }

    if (!menu || !openButton || !closeButton || menu.dataset.gBound === 'true') return;
    menu.dataset.gBound = 'true';

    var closeMenu = function () {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('g-menu-open');
      openButton.focus();
    };

    var openMenu = function () {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('g-menu-open');
      closeButton.focus();
    };

    openButton.addEventListener('click', openMenu);
    closeButton.addEventListener('click', closeMenu);
    menu.addEventListener('click', function (event) {
      if (event.target === menu) closeMenu();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
    });
  }

  function initFinder(root) {
    var finder = root.querySelector('[data-g-finder]');
    if (!finder || finder.dataset.gBound === 'true') return;
    finder.dataset.gBound = 'true';

    var select = finder.querySelector('[data-g-finder-select]');
    var result = finder.querySelector('[data-g-finder-result]');
    var power = finder.querySelector('[data-g-finder-power]');
    var title = finder.querySelector('[data-g-finder-title]');
    var copy = finder.querySelector('[data-g-finder-copy]');
    var link = finder.querySelector('[data-g-finder-link]');
    if (!select || !result || !power || !title || !copy || !link) return;

    var recommendations = {
      uk: {
        power: 'Up to 3.5 kW',
        title: '3-pin to Type 2 portable charger',
        copy: 'A straightforward overnight option for homes with a standard UK socket and no dedicated charging outlet.',
        url: finder.dataset.ukUrl
      },
      cee7: {
        power: 'Up to 7 kW',
        title: 'CEE to Type 2 portable charger',
        copy: 'For an existing single-phase CEE supply when you want a faster portable setup without a wallbox.',
        url: finder.dataset.ceeUrl
      },
      cee11: {
        power: 'Up to 11 kW',
        title: 'Three-phase CEE portable charger',
        copy: 'The higher-output portable route for compatible three-phase CEE power and vehicles that accept 11 kW AC charging.',
        url: finder.dataset.ceeUrl
      },
      v2l: {
        power: 'Vehicle specific',
        title: 'V2L adapter',
        copy: 'Use supported EVs as a mobile power source. The connector and protocol vary by vehicle, so compatibility must be confirmed first.',
        url: finder.dataset.v2lUrl
      }
    };

    var updateResult = function () {
      var item = recommendations[select.value] || recommendations.uk;
      result.classList.add('is-changing');
      window.setTimeout(function () {
        power.textContent = item.power;
        title.textContent = item.title;
        copy.textContent = item.copy;
        link.href = item.url || '/collections/all';
        result.classList.remove('is-changing');
      }, 130);
    };

    select.addEventListener('change', updateResult);
    updateResult();
  }

  function initFaq(root) {
    var lists = root.querySelectorAll('[data-g-faq-list]');
    lists.forEach(function (list) {
      if (list.dataset.gBound === 'true') return;
      list.dataset.gBound = 'true';
      list.querySelectorAll('details').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          list.querySelectorAll('details[open]').forEach(function (other) {
            if (other !== item) other.removeAttribute('open');
          });
        });
      });
    });
  }

  function init(root) {
    initHeader(root);
    initFinder(root);
    initFaq(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
